export const messages = {
  "admin_settings.routes.title": "Routes",
  "admin_settings.routes.subtitle":
    "Computed from each provider's code. A route changes by pull request, not here.",
  "admin_settings.routes.search": "Search routes by country, currency, or provider...",
  "admin_settings.routes.loading": "Loading routes…",
  "admin_settings.routes.load_failed": "Could not load the routes.",
  "admin_settings.routes.empty": "No corridors are offered.",
  "admin_settings.routes.no_match": "No corridors match your search.",
  "admin_settings.routes.corridor":
    "{sender_country} → {recipient_country}, {send_currency} → {receive_currency}",
  "admin_settings.routes.preferred": "Preferred",
  "admin_settings.routes.alternatives": "Alternatives",
  "admin_settings.routes.no_route": "No route can carry this corridor",
  "admin_settings.routes.settlement": "Settles in {asset}",
  "admin_settings.routes.rejection.corridor_not_offered": "BluPay does not offer this corridor.",
  "admin_settings.routes.rejection.no_onramp_leg":
    "No provider can collect {send_currency} in {sender_country}.",
  "admin_settings.routes.rejection.no_offramp_leg":
    "No provider can pay out {receive_currency} in {recipient_country}.",
  "admin_settings.routes.rejection.pair_not_allowed":
    "{onramp} → {offramp}: the routing policy does not allow this provider pair.",
  "admin_settings.routes.rejection.provider_disabled":
    "{onramp} → {offramp}: one of these providers is switched off.",
  "admin_settings.routes.rejection.leg_not_proven":
    "{onramp} → {offramp}: one of these legs is not proven yet.",
  "admin_settings.routes.rejection.amount_outside_onramp_limits":
    "{onramp} → {offramp}: the amount is outside the onramp's limits.",
  "admin_settings.routes.rejection.amount_outside_offramp_limits":
    "{onramp} → {offramp}: the amount is outside the offramp's limits.",
  "admin_settings.routes.rejection.no_settlement_asset":
    "{onramp} → {offramp}: the two legs share no settlement asset.",
  "admin_settings.routes.rejection.unknown": "{onramp} → {offramp}: {reason}.",
  "admin_settings.routes.rejection.unknown_corridor": "This corridor cannot be routed: {reason}.",
};

export function format(key, values = {}) {
  return messages[key].replace(/\{(\w+)\}/g, (_, name) => values[name] ?? "");
}
